import {
  hotelNameSelector,
  altAccoPropertyTypeSelector,
  isGoStaysSelector,
} from '@stencil/hotels-cg-reducer/src/details/selectors';
import {goingForwardPropertyIdSelector} from '@stencil/hotels-common-reducer/src/selectors';
import {appConfig, gaConfig} from '@stencil/hotels-config';
import {AnyAction} from 'redux';
import {ThunkAction, ThunkDispatch} from 'redux-thunk';
import {AppState} from '../../../verticals/hotels-dweb/src/shared/store';
import {pushEcommerceGAEvent, pushga} from '@stencil/ga-utils';
import roomStringUtils from '@stencil/hotels-utils/src/room-string-utils';
import {gaCheckinDateDifference} from '@stencil/hotels-utils/src/date-utils/date-utils';
import parseDateIntoHermesString from '@stencil/hotels-utils/src/date-utils/parse-date-into-hermes-string';
import gaFilterListShortName from '@stencil/hotels-utils/src/get-filter-list-short-name';
import dateFormat from 'dateformat';
import {FetchStatusType} from '@stencil/hotels-cg-reducer/src/details/types';
import {
  gaCustomerRatingBuckets,
  gaPriceBuckets,
  gaDiscountPercentageBuckets,
  gaAPWindowBuckets,
  isGpayMicroapp,
  setQuickBookCD,
  mergeUpsellWithPokusStr,
  getAugurExpFromStorage,
} from '@stencil/hotels-utils/src/common-utils';
import {detailsPagePushGaThunk} from '.';
import {dayUseNavigationMenuNames} from '@stencil/hotels-utils/src/get-dayuse-navigation-id-and-values';
import {DETAIL_SEO_PAGES} from '@stencil/hotels-utils/src/seo-utils';

export const gaPageViewMwebThunk = (
  pageName,
  additionalData: {} = {},
  cb = () => {},
): ThunkAction<void, AppState, {}, AnyAction> => {
  return (_: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    const storeState = getState();
    const {common, user, details = {}, review} = storeState;
    const {staticData = {}, hermesData = {}} = details || {};

    const {
      destination,
      checkin,
      checkout,
      roomString,
      partner,
      country,
      metaPartner,
      selectedHotel,
      userType,
      dayUseCheckinDate,
      checkinTime,
    } = common;
    const {userInfo, isLoggedIn} = user;
    const dateDelta =
      pageName !== 'review'
        ? gaCheckinDateDifference(checkin.date) + 1
        : gaCheckinDateDifference(checkin.date);
    const {mwebPageViewGAConfig} = gaConfig;
    let cdProfileSelected = 0;
    if (userInfo && userInfo.profileType) {
      const profileType = userInfo.profileType;
      cdProfileSelected = profileType.toLowerCase() === 'business' ? 1 : 0;
    }

    const augurExp = getAugurExpFromStorage();

    const destinationType = (destination && destination.t) || '';
    const cityName = destination?.ct?.n || destination?.n || '';
    const cityId = destination?.ct?._id || destination?._id || '';
    const checkinDateInHermesString =
      (checkin && checkin.date && parseDateIntoHermesString(checkin.date)) || '';
    const checkoutDateInHermesString =
      (checkout && checkout.date && parseDateIntoHermesString(checkout.date)) || '';

    let cdSubCatQueryVal = '';
    const hotelRating = staticData?.hr;
    const los =
      checkin && checkin.date && checkout && checkout.date
        ? Math.floor((checkout?.date?.getTime() - checkin?.date?.getTime()) / (1000 * 3600 * 24))
        : '';
    if (country) {
      if (country === appConfig.countryTextMap.india.key) {
        cdSubCatQueryVal = appConfig.countryTextMap.india.sec;
      } else {
        cdSubCatQueryVal = appConfig.countryTextMap.international.sec;
      }
    }
    const isGpayFunnel = isGpayMicroapp();

    let commonDataAcrossAllFunnels = {
      cdCatQuery: partner,
      cdHotelFunnelExperiment: 'newmhotels',
      cdSubCatQuery: cdSubCatQueryVal,
      userEmail: (userInfo && userInfo.email) || '',
      userid: (userInfo && userInfo.profileId) || '',
      cdCityName: cityName,
      cdLoggedIn: isLoggedIn,
      cdGeoEntity: destinationType,
    };

    if (userType) {
      commonDataAcrossAllFunnels['cdCaptivate_BookNow'] = userType;
    }

    let commonDataForMainFunnel = {
      // This is not required for seo-srp
      event: mwebPageViewGAConfig.mwebPageViewCommonEvent,
      cdCodePushversion: '',
      cdExtensionOfTrip: false,
      cdMidNight: checkin.isMidnight,
      cdExpLoc: false,
      VoyagerHotelCityID: cityId,
      cdHotelPaxSelection: roomString,
      cdHotelSearchKeyword: destinationType,
      cdTravelStyle:'',
      dpCheckIn: checkinDateInHermesString,
      dpCheckOut: checkoutDateInHermesString,
      dpRoomString: roomString,
      dpTimeStamp: parseDateIntoHermesString(new Date()),
      dpFilterList: gaFilterListShortName({}),
      cdDaysToBooking: dateDelta < 0 ? gaAPWindowBuckets(0) : gaAPWindowBuckets(dateDelta),
      cdLOS: los,
      cdHotelSearchRooms: roomString,
      cdCityVoy: cityId,
      cdsearchtype: destinationType,
      cdPayMode: isGpayFunnel ? 'gpay' : '',
      cdRnplcc: augurExp,
    };

    let data = {};

    let userSearchEventData = {};
    let apiLoadTime;
    switch (pageName) {
      case dayUseNavigationMenuNames.srp:
        data = {
          cdCatQuery: 'hourly',
          cdSlotCheckinTime: checkinTime,
        };
        break;
      case 'srp': {
        data = {
          screenName: mwebPageViewGAConfig.screenNames[pageName],
          cdusertype: '-1',
          cdHydraSegment: [],
          cdRnplcc: '-1',
        };
        userSearchEventData = {
          event: mwebPageViewGAConfig.mwebUserSearchEvent,
          searchCityName: cityName,
          searchCityVoy: cityId,
          searchHotelVoy: '-1',
          searchHotellName: '-1',
          searchType: destinationType,
          searchLocName: destinationType === 'city' ? '-1' : destination.n,
          searchLocVoy: destinationType === 'city' ? '-1' : destination._id,
        };
        break;
      }

      case 'details':
      case DETAIL_SEO_PAGES.review: {
        const propertyName = hotelNameSelector(storeState);
        const propertyId = goingForwardPropertyIdSelector(storeState);
        const propertyType = altAccoPropertyTypeSelector(storeState);
        const hydraSeg = hermesData?.hydra_seg || [];
        const isGoSuggest = isGoStaysSelector(storeState);
        const isAltAcco = hermesData?.meta_info?.flags?.hasOwnProperty('is_aa');

        let objDetails = {};

        if (isAltAcco) {
          Object.assign(objDetails, {cdaltacc: hermesData?.meta_info?.flags?.is_aa});
        } else {
          Object.assign(objDetails, {cdaltacc: ''});
        }

        data = {
          screenName: mwebPageViewGAConfig.screenNames[pageName],
          cdHotelSearchKeyword: propertyName,
          VoyagerHotelID: propertyId,
          event: mwebPageViewGAConfig.mwebPageViewCommonEvent,
          cdIsGosuggest: isGoSuggest,
          propertyType,
          cdHotelRating: hotelRating,
          cdHydraSegment: hydraSeg,
          cdCustomerRating: gaCustomerRatingBuckets(staticData?.gr),
          cdrankonsrp: 0,
          cdusertype: hermesData?.meta_info?.utn || '-1',
          ...objDetails,
        };
        userSearchEventData = {
          event: mwebPageViewGAConfig.mwebUserSearchEvent,
          searchCityName: staticData?.c,
          searchCityVoy: staticData?.vcid,
          searchHotelVoy: staticData?.hc || selectedHotel.propertyId || '-1',
          searchHotellName: staticData?.hn || selectedHotel.propertyName || '-1',
          searchType: propertyType,
          searchLocName: staticData?.l || '-1',
          searchLocVoy: '999999',
        };
        break;
      }

      case 'roomSelection': {
        const propertyId = goingForwardPropertyIdSelector(storeState);
        const isGoSuggest = isGoStaysSelector(storeState);
        const isAltAcco = hermesData?.meta_info?.flags?.hasOwnProperty('is_aa');
        const propertyType = altAccoPropertyTypeSelector(storeState);

        let objRoomSelection = {};

        if (isAltAcco) {
          Object.assign(objRoomSelection, {cdaltacc: hermesData?.meta_info?.flags?.is_aa});
        } else {
          Object.assign(objRoomSelection, {cdaltacc: ''});
        }

        data = {
          screenName: mwebPageViewGAConfig.screenNames[pageName],
          VoyagerHotelCityID: '',
          VoyagerHotelID: propertyId,
          event: mwebPageViewGAConfig.mwebPageViewCommonEvent,
          cdIsGosuggest: isGoSuggest,
          propertyType,
          Vendor: '',
          cdCityName: '',
          cdHotelSearchKeyword: '',
          cdTravelStyle: '',
          cdHotelRating: hotelRating,
          ...objRoomSelection,
        };

        break;
      }
      case 'calendar':
      case 'myEarning':
        data = {
          screenName: mwebPageViewGAConfig.screenNames[pageName],
          eventLabel: additionalData?.amount,
        };
        break;
      case 'progressiveSearchForm':
      case 'locationFilters':
      case 'filters': {
        data = {
          screenName: mwebPageViewGAConfig.screenNames[pageName],
        };
        break;
      }
      case 'review': {
        const {descblockResponse = {}, descblockInput = {}} = review;
        const {activeRatePlanIndex, pokusExpData} = common;
        const {cdata = {}, userPreFill, hermes_exp} = descblockResponse;
        const {roomInfo = {}} = descblockInput;
        let upsellPokusStr = mergeUpsellWithPokusStr(pokusExpData, cdata?.response_map, hermes_exp);
        const propertyId = goingForwardPropertyIdSelector(storeState);
        let reviewObj = {};
        if (cdata?.alt_acco_info) {
          const cdaltacc = cdata?.alt_acco_info?.hasOwnProperty('alt_ty')
            ? Number(cdata?.alt_acco_info?.alt_ty)
            : 0;
          Object.assign(reviewObj, {cdaltacc: cdaltacc});
        } else {
          Object.assign(reviewObj, {cdaltacc: ''});
        }
        data = {
          screenName: mwebPageViewGAConfig.screenNames[pageName],
          cdPromoCode: descblockResponse?.promocode || '',
          propertyType: cdata?.old_property_type || '',
          cdPayMode:
            isGpayFunnel && cdata?.pay_mode ? `${cdata?.pay_mode}|gpay` : cdata?.pay_mode || '',
          cdHotelRating: hotelRating,
          cdCustomerRating: gaCustomerRatingBuckets(staticData?.gr),
          cdPayableAmount: gaPriceBuckets(cdata?.aftrpromototal),
          VoyagerHotelID: propertyId,
          cdHydraSegment: userPreFill?.UserInfo?.segments || [],
          cdRankOfRatePlan: roomInfo?.roomPlanIndex || 0,
          cdcouponcode: descblockResponse?.promocode || '',
          cdDiscountPerc:
            document.querySelectorAll('#review-price-discount')[0] &&
            document.querySelectorAll('#review-price-discount')[0]?.innerText &&
            gaDiscountPercentageBuckets(
              document.querySelectorAll('#review-price-discount')[0]?.innerText.split('%')[0],
            ),
          cdRN: cdata?.noofNights * cdata?.noofRooms,
          cdusertype: hermesData?.meta_info?.utn || '-1',
          cdPocusExp: upsellPokusStr,
          ...reviewObj,
        };
        apiLoadTime = cb();
        if (apiLoadTime) data = {...data, apiLoadTime};
        break;
      }
      default:
        break;
    }

    if (Object.keys(userSearchEventData).length) pushga(userSearchEventData);
    pushga({...commonDataAcrossAllFunnels, ...commonDataForMainFunnel, ...data, ...additionalData});
  };
};

export const gaEcomThunk = (eventName, data = {}): ThunkAction<void, AppState, {}, AnyAction> => {
  return (_: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    const {ecommerceEvents} = gaConfig;
    const {srpImpressionLanding, srpProductClick, detailsPageLanding, addToCart, ecomCheckout} =
      ecommerceEvents;
    const {common, details = {}, review, travellerDetails} = getState();
    const {country} = common;
    let ecommerce = {};
    let additionalData = {};
    switch (eventName) {
      case srpImpressionLanding:
      case srpProductClick: {
        const countryCheckVariable = country;

        const category =
          (countryCheckVariable === appConfig.countryTextMap.india.key &&
            appConfig.countryTextMap.india.category) ||
          (countryCheckVariable && appConfig.countryTextMap.international.category) ||
          '';

        const list = gaFilterListShortName({});
        if (eventName === srpImpressionLanding) {
          const impressions = [];
          ecommerce = {...ecommerce, impressions};
        } else {
          const {productDetails = {}, productPosition} = data;
          let click = {
            actionField: {
              action: 'click',
              list,
            },
            products: [],
          };
          if (Object.keys(productDetails).length) {
            const {
              spr: price = '',
              hn: name = '',
              hc: id = '',
              ch: brand = '',
              hr: variant = '',
            } = productDetails;
            click.products.push({
              price,
              name,
              id,
              brand,
              variant,
              position: productPosition,
              category,
            });
          } else return;
          ecommerce = {...ecommerce, click};
        }
        break;
      }
      case detailsPageLanding: {
        const {staticData, hermesData = {}, vhid} = details || {};
        const {
          cn: countryName,
          ch: detailsBrand,
          hn: hotelName,
          hr: variant = '',
        } = staticData || {};
        const {reg: roomList = []} = hermesData?.data || {};
        if (!roomList || !roomList.length) {
          // sold out
          return;
        }
        //   const isDetailsSeo = !!(window && typeof window.__initial_state__?.details?.staticData == 'object' && Object.keys(window.__initial_state__?.details?.staticData).length)
        const roomOneRpl = roomList[0].rpl && roomList[0].rpl.length ? roomList[0].rpl[0] : {};
        const {pd = {}} = roomOneRpl;
        const {spr: hotelPrice = 0} = pd;

        // couldn't confirm if this is okay to do, domino has a weird dependency of a 'searchQuery' existence
        // which is a developer level state set which has common state on like city id et all…
        const detailsListName = 'L_H_D';

        const detailsCategory =
          countryName === appConfig.countryTextMap.india.value
            ? appConfig.countryTextMap.india.category
            : appConfig.countryTextMap.international.category;

        let detail = {
          actionField: {
            list: detailsListName,
            action: 'detail',
          },
          products: [
            {
              brand: detailsBrand,
              category: detailsCategory,
              id: vhid,
              name: hotelName,
              price: hotelPrice,
              variant,
            },
          ],
        };
        ecommerce = {...ecommerce, detail};
        const hepp = hermesData?.meta_info?.hepp;
        if (hepp) {
          const is_direct_traffic = hepp.length > 2 ? hepp[2].t : hepp[1].t;
          additionalData = {is_direct_traffic: is_direct_traffic};
        }
        break;
      }

      case addToCart: {
        const {staticData = {}, vhid} = details || {};
        const {cn: countryName, ch: brand, hn: hotelName, hr: variant = ''} = staticData || {};
        const category =
          countryName === appConfig.countryTextMap.india.value
            ? appConfig.countryTextMap.india.category
            : appConfig.countryTextMap.international.category;
        const {currency = '', showPrice = ''} = data;
        let add = {
          products: [
            {
              brand: brand,
              category,
              id: vhid,
              name: hotelName,
              price: showPrice,
              variant,
            },
          ],
        };
        ecommerce = {...ecommerce, currencyCode: currency, add};
        break;
      }

      case ecomCheckout: {
        const {descblockResponse = {}, descblockInput} = review;
        const {formData} = travellerDetails;
        if (!descblockResponse?.cdata) return;
        const {
          HotelName = '',
          HotelRating = [],
          is_domestic,
          RoomTypeName = '',
          personalized_keys,
          aftrpromototal = '',
        } = descblockResponse?.cdata;

        const {hc: hotelCode} = descblockInput;

        const payableAmount = (personalized_keys ? personalized_keys?.np_wt : aftrpromototal) || 0;

        let checkout = {
          actionField: {step: 1, option: ''},
          products: [
            {
              name: HotelName,
              id: hotelCode,
              price: payableAmount,
              brand: '',
              category:
                is_domestic === 1
                  ? appConfig.countryTextMap.india.category
                  : appConfig.countryTextMap.international.category,
              variant: HotelRating.length - 1,
              quantity: 1,
            },
          ],
        };
        additionalData = {
          weHotelPrice: payableAmount,
          weHotelStarRating: HotelRating !== undefined ? HotelRating.length - 1 : '',
          weRoomTypeName: RoomTypeName,
          weEmail: formData?.email || '',
        };

        ecommerce = {...ecommerce, checkout};
        break;
      }
      default:
        break;
    }
    const path = (window && window.location && window.location.pathname) || '';

    pushEcommerceGAEvent({ecommerce, event: eventName, path, ...additionalData});
  };
};

export const gaGoogleRTThunk = (
  pageType: string = 'home',
  additionalData: {
    siteType?: 'd' | 'm';
  } = {},
): ThunkAction<void, AppState, {}, AnyAction> => {
  return (_: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    const {common, user, details = {}, review} = getState();
    const {destination, checkin, checkout, roomString, partner, country, metaPartner} = common;

    const {userInfo} = user;

    const {adultCount, room} = roomStringUtils.getRoomConfig(roomString);

    let commonData = {
      hrental_id: [],
      hrental_pagetype: pageType,
      hrental_totalvalue: '',
      hrental_startdate: dateFormat(checkin.date, 'yyyy-mm-dd'),
      hrental_enddate: dateFormat(checkout.date, 'yyyy-mm-dd'),
      hrental_locid: '',
      email: userInfo.email ? userInfo.email : '',
      hashedemail: userInfo.email ? userInfo.email : '',
      sitetype: additionalData.siteType || 'd',
      adultCount,
      roomCount: room,
      pagetype: pageType,
    };

    let sector = 0;
    switch (pageType) {
      case 'results': {
        commonData.hrental_id = [];
        commonData.hrental_pagetype = 'searchresults';
        commonData.hrental_locid = destination?._id || '';
        commonData.email = userInfo.email ? userInfo.email : '';
        commonData.hashedemail = userInfo.email ? userInfo.email : '';
        commonData.sector = sector;
        break;
      }
      case 'details':
      case DETAIL_SEO_PAGES.review: {
        const {staticData: targetData = {}, hermesData: pricingTargetData = {}} = details || {};
        const priceData = pricingTargetData.data ? pricingTargetData.data : {};
        const roomType = 'reg';
        const roomList = priceData[roomType] || [];
        const roomOneRpl =
          roomList[0] && roomList[0].rpl && roomList[0].rpl.length ? roomList[0].rpl[0] : {};
        const {pd = {}} = roomOneRpl;
        const {spr = 0} = pd;

        const {lid = '', hc = '', vcid = '', cn = '', minprice = 0} = targetData;
        if (cn) {
          sector = cn.toLowerCase() === 'india' ? 0 : 1;
        }
        commonData.hrental_id = hc;
        commonData.hrental_totalvalue = spr || minprice;
        commonData.hrental_pagetype = 'product';
        commonData.hrental_locid = lid || destination._id;
        commonData.email = userInfo.email ? userInfo.email : '';
        commonData.hashedemail = userInfo.email ? userInfo.email : '';
        commonData.hrental_vcid = vcid;
        commonData.sector = sector;
        break;
      }
      case 'cart': {
        const {descblockResponse: descblock, descblockInput} = review;
        const {cdata = {}} = descblock;

        const {is_domestic, personalized_keys, aftrpromototal} = cdata;
        const {strQry, hc: vhid} = descblockInput;
        const strQuery = strQry ? strQry.split('-') : [];
        const vcid = strQuery[1] || '';

        commonData.hrental_id = vhid;
        commonData.hrental_locid = vcid;
        commonData.hrental_totalvalue =
          (personalized_keys ? personalized_keys.np_wt : aftrpromototal) || 0;
        commonData.sector = is_domestic ? 0 : 1;
        break;
      }
      default:
        break;
    }

    pushga({
      event: 'googleRT',
      google_tag_params: {...commonData},
    });
  };
};

export const gaBotTrafficIdentification = (
  pageType: string = 'home',
  additionalData: {
    siteType?: 'd' | 'm';
  } = {},
): ThunkAction<void, AppState, {}, AnyAction> => {
  return (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    const {details = {}} = getState();
    const {siteType = 'd'} = additionalData;
    let isBotTraffic = false,
      botSubCategory = null,
      eventCategory;
    switch (pageType) {
      case 'srp':
        isBotTraffic = false;
        botSubCategory = '';
        eventCategory = gaConfig.SrpGAEvents.hotelSrpClicks;
        break;
      case 'details':
      case DETAIL_SEO_PAGES.review:
        isBotTraffic = details?.hermesData?.meta_info?.bi?.is_ab;
        botSubCategory = details?.hermesData?.meta_info?.bi?.btd?.abt;
        eventCategory =
          siteType == 'm'
            ? gaConfig.mwebDetailsPageGAEvents.category
            : gaConfig.detailsPageClickEventCategoryName;
        break;
    }

    if (isBotTraffic) {
      pushga({
        eventCategory: eventCategory,
        eventAction: 'bot_traffic',
        eventLabel: botSubCategory,
      });
    }
  };
};

export const gaBotTrafficClientIdentification = (
  pageType: string = 'home',
  additionalData: {
    siteType?: 'd' | 'm';
  } = {},
): ThunkAction<void, AppState, {}, AnyAction> => {
  return (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    const {common} = getState();
    const {siteType = 'd'} = additionalData;
    let isBotTraffic = false,
      botSubCategory = null,
      eventCategory,
      clientIP = '';
    // isBotTraffic = common?.botDetection?.bot_detected;
    // botSubCategory = common?.botDetection?.value || '';
    // let clientIP = common?.botDetection?.client_ip_address;
    try {
      isBotTraffic = window?.client_bot_data?.bot_detected;
      botSubCategory = window?.client_bot_data?.value || '';
      clientIP = window?.client_ip_address;
    } catch (error) {}

    const isGpayFunnel = isGpayMicroapp();

    switch (pageType) {
      case 'home':
        eventCategory = gaConfig.HomePageGAEvents.homepageView;
        break;
      case 'srp':
        eventCategory = gaConfig.SrpGAEvents.hotelSRPLoaded;
        break;
      case 'details':
      case DETAIL_SEO_PAGES.review:
        eventCategory =
          siteType == 'm'
            ? gaConfig.mwebDetailsPageGAEvents.category
            : gaConfig.detailsPageClickEventCategoryName;
        break;
    }
    let gaObj = {
      eventCategory: eventCategory,
      eventAction: 'client_bot_traffic',
      eventLabel: botSubCategory,
      client_ip_address: clientIP,
    };
    if (pageType === 'home' && isGpayFunnel) {
      gaObj = {...gaObj, cdPayMode: 'gpay'};
    }
    pushga(gaObj);
  };
};

const pokusKeysAllowed = appConfig.pokusKeysAllowed;

export const gaPokusData = (
  pageType: string = 'home',
  additionalData: {
    siteType?: 'd' | 'm';
    data?: object;
  } = {},
): ThunkAction<void, AppState, {}, AnyAction> => {
  return (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    const {common} = getState();
    const {siteType = 'd', data = {}} = additionalData;
    const {fetchPokusDataStatus, pokusExpData} = common;
    var pokusExpGaData = '';

    for (let key in data) {
      pokusExpGaData += `${key}::${data[key]}##`;
    }

    for (let key in pokusExpData) {
      if (pokusKeysAllowed.indexOf(key) > -1) {
        pokusExpGaData += `${key}::${pokusExpData[key]}##`;
      }
    }
    let eventCategory = '';

    const handlePokusPushGa = (eventCategory, callback?: any) => {
      if (fetchPokusDataStatus === FetchStatusType.RESOLVED) {
        if (callback) {
          dispatch(
            callback({
              eventCategory: eventCategory,
              eventAction: 'pokus_exp',
              eventLabel: pokusExpGaData,
              customDimensions: {cdPocusExp: pokusExpGaData},
            }),
          );
        } else {
          pushga({
            eventCategory: eventCategory,
            eventAction: 'pokus_exp',
            eventLabel: pokusExpGaData,
            cdPocusExp: pokusExpGaData,
          });
        }
      } else if (fetchPokusDataStatus === FetchStatusType.REJECTED) {
        if (callback) {
          dispatch(
            callback({
              event: gaConfig.PocusExpEvent,
              eventCategory: eventCategory,
              eventAction: 'Pokus_Not_Received',
              customDimensions: {cdPocusExp: 'Pokus_Not_Received'},
            }),
          );
        } else {
          pushga({
            event: gaConfig.PocusExpEvent,
            eventCategory: eventCategory,
            eventAction: 'Pokus_Not_Received',
            cdPocusExp: 'Pokus_Not_Received',
          });
        }
      }
    };

    switch (pageType) {
      case 'home':
        eventCategory = gaConfig.HomePageGAEvents.homepageView;
        handlePokusPushGa(eventCategory);
        break;
      case 'srp':
        eventCategory = gaConfig.SrpGAEvents.hotelSRPLoaded;
        handlePokusPushGa(eventCategory);
        break;
      case 'details':
        eventCategory =
          siteType == 'm'
            ? gaConfig.mwebDetailsPageGAEvents.category
            : gaConfig.detailsPageClickEventCategoryName;
        handlePokusPushGa(eventCategory, detailsPagePushGaThunk);
        break;
      case DETAIL_SEO_PAGES.review:
        eventCategory =
          siteType == 'm'
            ? gaConfig.mwebDetailsReviewPageGAEvents.category
            : gaConfig.detailsPageGAEvents.category;
        handlePokusPushGa(eventCategory);
    }
  };
};
